import { Borrower } from 'app/models/dto/borrower.model';

export class GetBorrower {
	static readonly type = '[Borrower] Get';
	constructor(
	  public borrowerId: number,
    public refresh?: boolean,
    public addBorrowerTab?: boolean,
  ) {}
}

export class GetBorrowerProfile {
	static readonly type = '[Borrower] Get Borrower Profile';
	constructor(public borrowerId: number) {}
}

export class UpdateBorrower {
	static readonly type = '[Borrower] Update';
	constructor(public borrowerId: number, public updates: any) {}
}

export class UpdateBorrowerProfile {
	static readonly type = '[Borrower] Update Profile';
	constructor(public borrowerId: number, public updates: any) {}
}

export class AssignEmbeddedBorrower {
  static readonly type = '[Borrower] Assign Embedded Borrower';
  constructor(public borrowerId: number) {}
}

export class ClearBorrowerStore {
	static readonly type = '[Borrower] Clear';
	constructor() {}
}

export class PatchBorrower {
	static readonly type = '[Borrower] Patch';
	constructor(public borrower: Borrower) {}
}

export class SubscribeToBorrower {
	static readonly type = '[Borrower] Subscribe To Borrower';
	constructor(public borrowerId: number) {}
}

export class UnsubscribeToBorrower {
	static readonly type = '[Borrower] Unsubscribe To Borrower';
	constructor(public borrowerId: number) {}
}

export class UpdateAssignedUserId {
	static readonly type = '[Borrower] Update Assigned UserId';
	constructor(public borrowerId: number, public updates: any) {}
}

export class GetBorrowerOwnerHistory {
	static readonly type = '[Borrower] Get Borrower Owner History';
	constructor(public borrowerId: number) {}
}

export class GetPartnerRestrictedStatus {
	static readonly type = '[Borrower] Get Partner Restricted Status';
	constructor(public borrowerId: number) {}
}

export class ShareBorrower {
	static readonly type = '[Borrower] Share Borrower';
	constructor(public borrowerIds: number[], public userIds: number[]) {}
}

export class UnshareBorrower {
	static readonly type = '[Borrower] Unshare Borrower';
	constructor(public borrowerIds: number[], public unsharedUserIds: number[], public removeFromQueue: boolean | null = null) {}
}

export class ChangeBorrowerStatus {
  static readonly type = '[Borrower] ChangeBorrowerStatus';
  constructor(
    public borrowerId: number,
    public status: string,
    public reason: string | null,
    public dncParams?: {
      isNyState?: boolean | null;
      methods?: Array<string>;
    }
  ) {}
}

export class MoveBorrowerOutOfComplianceReview {
  static readonly type = '[BorrowerValue] MoveBorrowerOutOfComplianceReview';
  constructor(
    public borrowerId: number
  ) {}
}

export class ChangeBorrowerAssignment {
  static readonly type = '[Borrower] ChangeBorrowerAssignment';
  constructor(
    public borrowerId: number,
    public userId: number
  ) {}
}

export class RemoveApprovalsExperiment {
	static readonly type = '[Borrower] RemoveApprovalsExperiment';
	constructor(
		public borrowerId: number,
		public userId: number
	) {}
}

export class GetERCInterest {
	static readonly type = '[Borrower] GetERCInterest';
	constructor(
		public borrowerId: number
	) {}
}

export class GetRenewalEligibilityDate {
  static readonly type = '[Borrower] GetRenewalEligibilityDate';
  constructor(
    public borrowerId: number
  ) {}
}
